module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.active_pay) ? _c('md-list-item', [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators")]), _vm._v(" "), _c('md-list-expand', {
    staticClass: "ql-invite-form"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Find Existing User")]), _vm._v(" "), _c('md-autocomplete', {
    attrs: {
      "fetch": _vm.filter,
      "print-attribute": "username",
      "min-chars": 0,
      "max-height": 6,
      "max-res": 0,
      "debounce": 500,
      "width": "100%"
    },
    on: {
      "selected": _vm.inviteCallback
    },
    model: {
      value: (_vm.autoCompleteInvitee),
      callback: function($$v) {
        _vm.autoCompleteInvitee = $$v
      },
      expression: "autoCompleteInvitee"
    }
  })], 1), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inviting),
      expression: "!inviting"
    }],
    attrs: {
      "nvalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.inviteNew($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.email),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "email", $$v)
      },
      expression: "newInvitee.email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.name),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "name", $$v)
      },
      expression: "newInvitee.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.role),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "role", $$v)
      },
      expression: "newInvitee.role"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "type": "submit"
    }
  }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" Send Invite")], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.resetInvitee
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && !_vm.emailSent),
      expression: "inviting && !emailSent"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && _vm.emailSent),
      expression: "inviting && emailSent"
    }],
    attrs: {
      "id": "done-icon"
    }
  }, [_vm._v("done")])], 1)], 1)], 1) : _c('md-list-item', [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators (disabled)")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f16e74a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/collaborators/invite.vue
// module id = 636
// module chunks = 2